<div *ngIf="TestMonialData.length > 0" class="thumbnails">
  <div class="testimonial-carousel">
    <div class="testimonial-flipster">
      <ul [class.single-item]="TestMonialData.length === 1">
        <li
          *ngFor="let product of TestMonialData; let pIdx = index"
          [id]="'q' + product.title + pIdx"
          class="testimonial-item"
        >
          <div class="product-item-new">
            <div class="product-item-content">
              <div class="product-header">
                <div class="image">
                  <img [src]="product.uri" [alt]="" alt="" />
                </div>
                <div class="userProfile">
                  <h4>
                    {{ product.field_testimonial_name }}
                  </h4>
                  <h6 class="designation">{{ product.field_testimonial_designation }}</h6>
                </div>
              </div>
              <div class="content">
                <p [innerHtml]="product.body"></p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
